// modules
import { RForm } from '@/components/reusable_components/next'
import AccAccountingSeatConceptService from '@/services/api/accounting/AccAccountingSeatConcept'
import TranslatorService from '@/services/translator'

// partials
import AccAccountingSeatConceptFields from "@/views/Accounting/AccAccountingSeatConcept/fields"

// components
export default {
  components: {
    RForm,
  },
  computed: {

    /**
     * 
     */
    formProps() {
      return {
        fields: AccAccountingSeatConceptFields.toCreate(),
      }
    }
  },
  data() {
    return {
      accAccountingSeatConcept: AccAccountingSeatConceptService.toCreate(),
    }
  },
  methods: {

    /**
     * 
     */
    create() {
      return AccAccountingSeatConceptService.create(this.accAccountingSeatConcept).then(this.onSuccess).then(this.goList).catch(this.onError)
    },

    /**
     *  
     */
    goList() {
      this.$router.push({ name: 'acc-accounting-seat-concept-list' })
    },

    /**
     * 
     */
    onError(error) {
      this.showErrorSnackbar(TranslatorService(AccAccountingSeatConceptService.model(), error.response.data))
    },
    
    /**
     * 
     */
    onReset() {
      this.accAccountingSeatConcept = AccAccountingSeatConceptService.toCreate()
    },
    
    /**
     * 
     */
    onSubmit() {
      this.$refs.form.setWait(true).then(this.create).then(this.$refs.form.setWait)
    },

    /**
     * 
     */
    onSuccess() {
      this.showSuccessSnackbar('Concepto creado exitosamente.')
    },
  },
  mounted() {
    this.setTitle('Crear concepto')
    this.onReset()
  }
}